import React from "react";

import Col from "react-bootstrap/Col";
import { IoIosTimer } from "react-icons/io";

import { NavLink } from "react-router-dom";
import { PALETTE } from "../../common/ThemeConstants";

export default function TimerIconTab({
  image,
  imageHovered,
  imageActive,
  to,
  text = "",
  width = 50,
  px = true,
  pulse = false,
  onClick = () => { }
}) {
  const onMouseEnter = (e, isActive) => {
    if (isActive && to !== "") {
      return;
    }

    if (!pulse) {
      e.currentTarget.children[0].src = imageHovered;
    }

    if (e.currentTarget.children[0] && pulse) {
      e.currentTarget.children[0].style.background = PALETTE.RED;
      e.currentTarget.children[0].style.color = PALETTE.WHITE;
    }
  };

  const onMouseLeave = (e, isActive) => {
    if (isActive && to !== "") {
      return;
    }

    if (!pulse) {
      e.currentTarget.children[0].src = image;
    }

    if (e.currentTarget.children[0] && pulse) {
      e.currentTarget.children[0].style.background = "transparent";
      e.currentTarget.children[0].style.color = PALETTE.RED;
    }
  };

  return (
    <Col
      className={`text-center align-self-center ${!px && "px-0"}`}
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <NavLink
        to={to}
        style={{
          textDecoration: "none",
        }}
      >
        {({ isActive }) => (
          <div
            onMouseEnter={(e) => onMouseEnter(e, isActive)}
            onMouseLeave={(e) => onMouseLeave(e, isActive)}
          >
            {image && !text && (
              <img
                src={isActive && to !== "" ? imageActive : image}
                width={width}
                alt={text}
              />
            )}

            {/* {text && image && (
              <div
                className={`badge rounded-pill shadow-sm blur`}
                style={{
                  fontSize: 14,
                  fontWeight: pulse ? "bold" : "normal",
                  marginLeft: pulse ? -41 : -38,
                  marginTop: 24,
                  position: "absolute",
                  color: pulse ? PALETTE.RED : PALETTE.KINDAGRAY,
                  animation: pulse ? "pulse 1s infinite" : "none"
                }}
              >
                {text}
              </div>
            )} */}
            {text && !image && (
              <div
                className="text-center rounded-pill px-1"
                style={{
                  fontSize: 14,
                  fontWeight: pulse ? "bold" : "bold",
                  color: pulse ? PALETTE.RED : PALETTE.TRUEGRAY,
                  border: `2px solid ${pulse ? PALETTE.RED : PALETTE.TRUEGRAY}`,
                  animation: pulse ? "pulse 1s infinite" : "none",
                }}
              >
                {text}
              </div>
            )}
          </div>
        )}
      </NavLink>
    </Col >
  );
}
